import {
  UPDATE_DP_FOOTNOTE_SOFT_SAVE,
  CLEAR_DP_FOOTNOTE_SOFT_SAVE
} from "src/DigitalProtocolModule/constants";

interface FootnoteSoftSave {
    insert: DPFootnote.PayloadType[]
    update: DPFootnote.PayloadType[]
    delete: number[]
}

const initialFootnoteSave: FootnoteSoftSave = {
    insert: [],
    update: [],
    delete: [],
};

const dpFootnoteSoftSaveReducer = (state = initialFootnoteSave, action) => {
  switch (action.type) {
    case UPDATE_DP_FOOTNOTE_SOFT_SAVE:
      state = {
        ...state,
        ...action.payload,
      };
      break;
    case CLEAR_DP_FOOTNOTE_SOFT_SAVE:
      state = {
        ...initialFootnoteSave
      };
      break;
    default:
  }
  return state;
};

export default dpFootnoteSoftSaveReducer;